import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import qapi from 'views_shared/app/javascript/api';
import qlog from 'views_shared/app/javascript/scripts/qlog';
import ImageCropped from 'views_shared/app/javascript/components/ImageCropped';
import PortalTooltip from 'views_shared/app/javascript/components/PortalTooltip';
import { profileUrl } from 'views_shared/app/javascript/utils/urls';

import CollapsibleSection from '../CollapsibleSection';

function TeammatesSection({ profileSlug, profileFirstName = '', teamId }) {
  const [teammates, setTeammates] = useState([]);

  useEffect(() => {
    setTeammates([]);

    if (!teamId) return undefined;

    let cancelled = false;

    const fetchTeammates = async () => {
      try {
        const result = await qapi.userProfiles.getByTeamId(teamId);
        if (cancelled) return;

        if (!result.error && Array.isArray(result.data)) {
          const others = result.data.filter((p) => p.slug !== profileSlug);
          setTeammates(others);
        } else if (result.error) {
          qlog.error('Failed to fetch teammates:', result.error);
        }
      } catch (error) {
        if (!cancelled) {
          qlog.error('Failed to fetch teammates:', error);
        }
      }
    };

    fetchTeammates();

    return () => {
      cancelled = true;
    };
  }, [teamId, profileSlug]);

  if (teammates.length === 0) return null;

  return (
    <CollapsibleSection title={profileFirstName ? `${profileFirstName}'s Teammates` : 'Teammates'}>
      <div className="p-3 pt-0 d-flex flex-wrap gap-3">
        {teammates.map((tm) => (
          <PortalTooltip
            key={tm.slug}
            content={(
              <>
                <p className="fw-bold text-default mb-0">{tm.name}</p>
                {tm.title_at_workplace && <p className="text-secondary mb-0">{tm.title_at_workplace}</p>}
              </>
            )}
          >
            <a href={profileUrl(tm)} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
              <ImageCropped
                roundedCircle
                src={tm.profile_image_url}
                alt={tm.name}
                size={48}
                style={{ cursor: 'pointer' }}
                fallbackToInitials
              />
            </a>
          </PortalTooltip>
        ))}
      </div>
    </CollapsibleSection>
  );
}

TeammatesSection.propTypes = {
  profileSlug: PropTypes.string.isRequired,
  profileFirstName: PropTypes.string,
  teamId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TeammatesSection;
